import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import UserRolesAPI from '../../api/userRoles';

export const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

export const getters = {
  getUserRoles($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async function get({ commit }) {
    commit('SET_USER_ROLE_UI_FLAG', { fetchingList: true });
    try {
      const response = await UserRolesAPI.get();
      commit('SET_USER_ROLE', response.data);
      commit('SET_USER_ROLE_UI_FLAG', { fetchingList: false });
    } catch (error) {
      commit('SET_USER_ROLE_UI_FLAG', { fetchingList: false });
    }
  },

  create: async function create({ commit }, userRoleObj) {
    commit('SET_USER_ROLE_UI_FLAG', { creatingItem: true });
    try {
      const response = await UserRolesAPI.create(userRoleObj);
      commit('ADD_USER_ROLE', response.data);
      commit('SET_USER_ROLE_UI_FLAG', { creatingItem: false });
      return response.data;
    } catch (error) {
      commit('SET_USER_ROLE_UI_FLAG', { creatingItem: false });
      return throwErrorMessage(error);
    }
  },

  update: async function update({ commit }, { id, ...updateObj }) {
    commit('SET_USER_ROLE_UI_FLAG', { updatingItem: true });
    try {
      const response = await UserRolesAPI.update(id, updateObj);
      commit('EDIT_USER_ROLE', response.data);
      commit('SET_USER_ROLE_UI_FLAG', { updatingItem: false });
      return response.data;
    } catch (error) {
      commit('SET_USER_ROLE_UI_FLAG', { updatingItem: false });
      return throwErrorMessage(error);
    }
  },

  delete: async function deleteItem({ commit }, id) {
    commit('SET_USER_ROLE_UI_FLAG', { deletingItem: true });
    try {
      await UserRolesAPI.delete(id);
      commit('DELETE_USER_ROLE', id);
      commit('SET_USER_ROLE_UI_FLAG', { deletingItem: false });
      return id;
    } catch (error) {
      commit('SET_USER_ROLE_UI_FLAG', { deletingItem: false });
      return throwErrorMessage(error);
    }
  },

  updateUserLimit: async function updateUserLimit(
    { commit },
    { roleId, accountUserId, maxConversationsOverride }
  ) {
    commit('SET_USER_ROLE_UI_FLAG', { updatingItem: true });
    try {
      const response = await UserRolesAPI.updateUserLimit(
        roleId,
        accountUserId,
        maxConversationsOverride
      );
      commit('EDIT_USER_ROLE', response.data);
      commit('SET_USER_ROLE_UI_FLAG', { updatingItem: false });
      return response.data;
    } catch (error) {
      commit('SET_USER_ROLE_UI_FLAG', { updatingItem: false });
      return throwErrorMessage(error);
    }
  },
};

export const mutations = {
  SET_USER_ROLE_UI_FLAG(_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  SET_USER_ROLE: MutationHelpers.set,
  ADD_USER_ROLE: MutationHelpers.create,
  EDIT_USER_ROLE: MutationHelpers.update,
  DELETE_USER_ROLE: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
